export default "__VITE_ASSET__2eff8681__"